'use es6';

import { BaseResponsiveToolbar, buildActionsForModuleInFlexColumn } from './BaseResponsiveToolbar';

/**
 * @param {string} props.responsiveSize (required)
 * @param {boolean} props.isInNonDefaultBreakpointMode (required)
 */
import { jsx as _jsx } from "react/jsx-runtime";
const MockResponsiveMobileModuleToolbarInFlexColumnToMeasure = ({
  responsiveSize,
  isInNonDefaultBreakpointMode
}) => {
  return /*#__PURE__*/_jsx(BaseResponsiveToolbar, {
    actions: buildActionsForModuleInFlexColumn({
      isInNonDefaultBreakpointMode
    }),
    responsiveSize: responsiveSize
  });
};

/**
 * @param {string} props.responsiveSize (required)
 */
const MockResponsiveDesktopModuleToolbarInFlexColumnToMeasure = ({
  responsiveSize
}) => {
  return /*#__PURE__*/_jsx(BaseResponsiveToolbar, {
    actions: buildActionsForModuleInFlexColumn({}),
    responsiveSize: responsiveSize
  });
};
export { MockResponsiveMobileModuleToolbarInFlexColumnToMeasure, MockResponsiveDesktopModuleToolbarInFlexColumnToMeasure };